var exports = {
  "kL": "x61f99309--6b2a69--container",
  "PQ": "x61f99309--6b2a69--border",
  "cy": "x61f99309--6b2a69--author",
  "rf": "x61f99309--6b2a69--body",
  "YW": "x61f99309--6b2a69--container--incoming",
  "Lr": "x61f99309--6b2a69--thumbnail-wrapper",
  "su": "x61f99309--6b2a69--icon-wrapper",
  "Qq": "x61f99309--6b2a69--text",
};

module.exports = exports;
